import React, { FC } from 'react';
import styled from 'styled-components';


export const Conteudo: FC<React.HTMLAttributes<HTMLElement>> = (props) => {
  return (
    <Container id="conteudo" {...props}/>
  )
}

const Container = styled.main`
  margin: 0 2rem;
  padding: .5rem 1rem;
  background: ${({theme}) => theme.background.nivel_1};

  @media (max-width: ${({theme}) => theme.tamanho.celular}) {
    margin: 0;
  }
`;